import { ActivityReportService as ActivityReportServiceClass } from 'go-modules/csv-report/activity-report/activity-report.service';
import { NgxFeatureFlagService } from '@go-modules/services/feature-flag/feature-flag.service';

export class ActivityReportPanelController {

	public activityId: string | number | null;
	public reportLevel: string;
	public groupId: string | number;
	public showNewReport: boolean;

	/* @ngInject */
	constructor (
		private ActivityReportService: ActivityReportServiceClass,
		private featureFlag: NgxFeatureFlagService
	) {
		this.showNewReport = this.featureFlag.isAvailable('NEW_ACTIVITY_REPORT');
	}

	public getReportTitle (): string {
		if (this.reportLevel === 'course') {
			return 'activity-report-panel_course-report';
		} else {
			return 'activity-report-panel_activity-report';
		}
	}

	public downloadReport (){
		this.ActivityReportService.execute(this.activityId, this.groupId);
	}
}
